import { Button, Col, DatePicker, Form, Input, Row, Select, Space } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { H6 } from "../../../../AbstractElements";
import {
  CurrencyApi,
  OrganisationBranchApi,
  ProjectApi,
} from "../../../../api";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const ProjectEdit = (props) => {
  const { Option } = Select;
  const formRef = useRef();
  const [branches, setBranches] = useState([]);
  const [currency, setCurrency] = useState([]);
  useEffect(() => {
    fetchProjectDetails();
    fetchCurrency();
    fetchBranches();
  }, []);
  const fetchProjectDetails = () => {
    axios.get(`${ProjectApi}${props.settings.project.id}/`).then((res) => {
      formRef.current.setFieldsValue({
        project_name: res.data?.project_name,
        project_code: res.data?.project_code,
        pincode: res.data?.pincode,
        city: res.data?.city,
        // branch: res.data?.branch,
        pincode: res.data?.pincode,
        start_date: moment(res.data?.start_date) ?? "",
        end_date: res.data?.end_date ? moment(res.data?.end_date) ?? "" : null,
        currency: res.data?.currency?.id,
        contact_email: res.data?.contact_email,
        contact_phone: res.data?.contact_phone,
        contact_person: res.data?.contact_person,
      });
    });
  };
  const fetchCurrency = () => {
    axios
      .get(`${CurrencyApi}`)
      .then((res) => {
        setCurrency(res.data);
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };
  const fetchBranches = () => {
    axios
      .get(`${OrganisationBranchApi}`)
      .then((res) => {
        setBranches(res.data?.filter((each) => each.organisation === 1));
      })
      .catch(() => {});
  };
  const currencyOption = currency?.map((each) => (
    <Option key={each.id} value={each.id}>
      {each.name}
      {` ( ${each.symbol} )`}
    </Option>
  ));
  const branchOption = branches?.map((each, ind) => (
    <Option key={ind} value={each.id}>
      {each.branch_name}
    </Option>
  ));
  const saveChanges = () => {
    const updatedValues = formRef.current.getFieldsValue();
    const values = new FormData();
    if (
      moment(updatedValues?.start_date).format("YYYY-MM-DD") !== "Invalid date"
    ) {
      values.append(
        "start_date",
        moment(updatedValues?.start_date).format("YYYY-MM-DD")
      );
    } else {
      values.append("start_date", moment().format("YYYY-MM-DD"));
    }
    if (
      moment(updatedValues?.end_date).format("YYYY-MM-DD") !== "Invalid date"
    ) {
      values.append(
        "end_date",
        moment(updatedValues?.end_date).format("YYYY-MM-DD")
      );
    } else {
      values.append("end_date", moment().format("YYYY-MM-DD"));
    }
    values.append("project_name", updatedValues?.project_name ?? "");
    values.append("project_code", updatedValues?.project_code ?? "");
    values.append("pincode", updatedValues?.pincode ?? "");
    values.append("city", updatedValues?.city ?? "");
    values.append("contact_phone", updatedValues?.contact_phone ?? "");
    values.append("contact_person", updatedValues?.contact_person ?? "");
    values.append("contact_email", updatedValues?.contact_email ?? "");
    values.append("currency", updatedValues?.currency ?? 1);

    // values.append("branch", updatedValues?.branch);
    axios
      .put(`${ProjectApi}${props.settings.project.id}/`, values)
      .then((res) => {
        toast.success("Changes Saved");
        fetchProjectDetails();
      })
      .catch((error) => {
        if (error?.response?.status == 405) {
          toast.error(error?.response?.data);
        } else {
          toast.error("Something went wrong!");
        }
      });
  };
  return (
    <React.Fragment>
      <div className="">
        <H6>Project Details</H6>
      </div>
      <div className="mt-2">
        <Form
          layout="vertical"
          id="projectForm"
          ref={formRef}
          onFinish={saveChanges}
        >
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"project_name"}
                label="Project name"
                rules={[
                  {
                    required: true,
                    pattern: /^[^*|\":<>[\]{}`\\()';@&$]+$/,
                    message: "Enter valid project name",
                  },
                ]}
              >
                <Input placeholder="Project name" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"project_code"}
                label="Project Code"
                rules={[
                  {
                    required: true,
                    message: "Project code is required",
                  },
                ]}
              >
                <Input placeholder="Project code" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"currency"} label="Currency">
                <Select placeholder="Enter Currency">{currencyOption}</Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"pincode"}
                label="Pincode"
                rules={[
                  {
                    pattern: /^[0-9]{6}$/,
                    message: "Enter a valid six digit pin code",
                  },
                ]}
              >
                <Input
                  showCount
                  maxLength={6}
                  minLength={6}
                  placeholder="Enter pincode"
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"city"}
                label="City"
                rules={[
                  {
                    pattern: /^[A-Za-z]+[A-Za-z ]*$/,
                    message: "Enter valid City",
                  },
                ]}
              >
                <Input placeholder="Enter city" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"contact_phone"}
                label="Contact Number"
                rules={[
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Enter a valid 10 digit contact number",
                  },
                ]}
              >
                <Input
                  maxLength={10}
                  minLength={10}
                  placeholder="Enter contact number"
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"contact_person"} label="Contact Person">
                <Input placeholder="Enter contact person" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"contact_email"} label="Email">
                <Input placeholder="Enter contact email" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"start_date"} label="Start Date">
                <DatePicker placeholder="Start Date" className="w-100" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item name={"end_date"} label="End Date">
                <DatePicker placeholder="End Date" className="w-100" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24} justify="end">
            <Col>
              <Space className="mb-0">
                <Button type="primary" htmlType="submit" form="projectForm">
                  {"Save Changes"}
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </div>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ProjectEdit);
